<mat-dialog-content>
  <form>
      <div class="col-12">
        <h1>Change Password</h1>
      </div>

      <div class="form-group col-md-3" *ngIf="!registerAction">
        <label for="oldPassword">{{'Current Password' | translate}}</label>
        <input type="password" [(ngModel)]="userDetails.secMemberships[0].oldPassword" name="userDetails.secMemberships[0].oldPassword"
          class="form-control" [required]="!passwordIsEmpty" id="oldPassword" #oldPassword="ngModel" updating="true">
        <small [hidden]="oldPassword.valid || !modifyPassword" class="incorrect-field">
          {{'Current Password is required' | translate}}
        </small>
      </div>

      <div class="form-group col-md-3">
        <label for="password">{{'New Password' | translate}}</label>
        <input type="password" [(ngModel)]="userDetails.secMemberships[0].password" name="userDetails.secMemberships[0].password"
          (ngModelChange)="userDetails.confirmPassword = ''" class="form-control" id="password" #password="ngModel"
          [required]="registerAction" reverse="true" validatePassword="userDetails.secMemberships[0].password" updating="true" validateEqual="userDetails.confirmPassword">
          <small [hidden]="password.valid || password.pristine" class="incorrect-field">
            {{'Password is invalid' | translate}}
          </small>
      </div>

      <div class="form-group col-md-3">
        <label for="confirmPassword">{{'Confirm New Password' | translate}}</label>
        <input type="password" [(ngModel)]="userDetails.confirmPassword" name="userDetails.confirmPassword"
          class="form-control" id="confirmPassword" #confirmPassword="ngModel"
          [required]="registerAction" updating="true" validateEqual="userDetails.secMemberships[0].password">
        <small [hidden]="confirmPassword.valid || confirmPassword.pristine" class="incorrect-field">
          {{'Passwords do not match' | translate}}
        </small>
      </div>

      <div class="col-md-3 password-rules">
        <ul>
          <li [ngClass]="checkPasswordError(password.errors, rule.id)" *ngFor="let rule of passwordRules">{{rule.description}}</li>
        </ul>
      </div>

  </form>
  <mat-dialog-actions id="action-buttons">
    <button class="btn btn-csc-primary" (click)="this.dialogRef.close()">Close</button>
    <button class="btn btn-csc-primary" (click)="changePassword(password.errors)">Change Password</button>
  </mat-dialog-actions>
</mat-dialog-content>

